import React from 'react';

import * as ContentList from '@/components/ContentList';
import GroupListItem from '@/components/Form/components/VisibilitySettings/components/RestrictedVisibilitySettingsSelectedList/components/RestrictedVisibilitySettingsSelectedGroupsList/components/RestrictedGroupListItem';
import { UserCollectionGroupType } from '@/types/schema';

import { UseLearnerAndGroupList } from '../../hooks/useLearnerAndGroupList';

interface GroupContentListProps {
  userGroupListItems: UseLearnerAndGroupList['userGroupListItems'];
  disabled?: boolean;
  disabledRemoveIds?: string[];
  onRemovegroup: UseLearnerAndGroupList['onRemovegroup'];
}

const GroupContentList: React.FC<GroupContentListProps> = ({
  userGroupListItems,
  disabled,
  disabledRemoveIds,
  onRemovegroup,
}) => {
  return (
    <ContentList.Provider items={userGroupListItems}>
      <ContentList.Items
        renderer={(index) => {
          const group = userGroupListItems[index] as UserCollectionGroupType;

          return (
            <GroupListItem
              key={group.id}
              disabled={disabled}
              group={group}
              hideRemoveButton={disabledRemoveIds?.includes(group.id)}
              mode="normal"
              onRemove={onRemovegroup}
            />
          );
        }}
      />
    </ContentList.Provider>
  );
};

export default GroupContentList;
